import { render, staticRenderFns } from "./NewEntryType.vue?vue&type=template&id=f89989ae&scoped=true"
import script from "./NewEntryType.vue?vue&type=script&lang=js"
export * from "./NewEntryType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89989ae",
  null
  
)

export default component.exports